import React from 'react'
import PropTypes from 'prop-types'
import { Panel, Hr, Margin, Table, Text } from 'shared/components'

const MembersComponent = ({ columns, loadMembers }) => (
  <Panel>
    <Text as="h1" size={16} bold>
      Members
    </Text>
    <Margin tb={3}>
      <Hr width="full" />
    </Margin>
    <Table id="members-table" columns={columns} loadData={loadMembers} />
  </Panel>
)

MembersComponent.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()),
  loadMembers: PropTypes.func,
}

export default MembersComponent
